import React from 'react';

const FilterButton = ({ className, loading, ...rest }) => (
  <div className={className}>
    <button
      className={`button is-warning${loading ? ' is-loading' : ''}`}
      {...rest}
      type="submit"
    >
      <span className="icon is-small">
        <i className="mi mi-search" />
      </span>
      <span>Filtra</span>
    </button>
  </div>
);

export default FilterButton;
